import { RootStore } from "../../store/RootStore";
import {
  downloadAllFilesInFolder,
  FileToDownload,
  DownloadResult,
  UserCancelledError,
} from "../utils/downloadAllFilesInFolder";

export interface FileDownloadConfig {
  downloadName: string;
  files: FileToDownload[];
}

export class FileDownloadService {
  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  async download(config: FileDownloadConfig): Promise<DownloadResult> {
    const { downloadName, files } = config;

    const progressStore = this.rootStore.downloadProgressStore;
    const { activityId } = this.rootStore.activityStore.startActivity("query", "batchFileDownload");

    const abortController = progressStore.startDownload(downloadName, files.length);

    try {
      const result = await downloadAllFilesInFolder(
        downloadName,
        files,
        (current, total, fileName, category) => {
          progressStore.updateProgress(current, total, fileName, category);
        },
        abortController.signal,
        (folderName) => progressStore.askOverwriteConfirmation(folderName)
      );

      progressStore.finishDownload();
      this.rootStore.activityStore.endActivity(activityId);

      return result;
    } catch (error) {
      progressStore.finishDownload();
      this.rootStore.activityStore.endActivity(activityId);

      if (error instanceof UserCancelledError) {
        return { total: files.length, successful: 0, failed: [] };
      }

      throw error;
    }
  }
}
